import { logger } from '@fiverr-private/obs';
import { isClient } from '../isClient';
import { reportGrafanaEvent } from '../events/grafana/reporter';
import { triggerApiMapSymbol, queuedTriggerMapSymbol, closeApiMapSymbol, queuedArgumentsMapSymbol, FALLBACK_TIMEOUT_MS } from './constants';

export class SigningModalManager {
    constructor() {
        if (!isClient()) {
            return;
        }

        window[triggerApiMapSymbol] = window[triggerApiMapSymbol] || new Map();
        window[queuedTriggerMapSymbol] = window[queuedTriggerMapSymbol] || new Map();
        window[closeApiMapSymbol] = window[closeApiMapSymbol] || new Map();
        window[queuedArgumentsMapSymbol] = window[queuedArgumentsMapSymbol] || new Map();
    }

    registerTriggerApi = (signingModalType, callback) => {
        if (!isClient()) {
            return;
        }

        window[triggerApiMapSymbol].set(signingModalType.name, callback);

        this.handleQueuedTrigger(signingModalType, callback);
    }

    handleQueuedTrigger = (signingModalType) => {
        if (!isClient()) {
            return;
        }

        const pendingCallbacks = window[queuedTriggerMapSymbol].get(signingModalType.name);

        if (!pendingCallbacks) {
            return;
        }

        const queuedArguments = window[queuedArgumentsMapSymbol].get(signingModalType.name) || [];

        this.trigger(signingModalType, ...queuedArguments);

        pendingCallbacks.forEach((callback) => callback());

        window[queuedTriggerMapSymbol].delete(signingModalType.name);
        window[queuedArgumentsMapSymbol].delete(signingModalType.name);
    }

    registerCloseApi = (signingModalType, callback) => {
        if (!isClient()) {
            return;
        }

        window[closeApiMapSymbol].set(signingModalType.name, callback);
    }

    trigger = async(signingModalType, ...args) => new Promise((resolve, reject) => {
        if (!isClient()) {
            return;
        }

        const triggerCallback = window[triggerApiMapSymbol].get(signingModalType.name);

        if (!triggerCallback) {
            const rejectTriggerTimeout = setTimeout(() => {
                logger.warn(`User Session Trigger: Failed to resolve a trigger for ${signingModalType.name}`);
                reportGrafanaEvent(`identification.trigger.regular.fail.${signingModalType.name}`);
                const existingPendingCallbacks = window[queuedTriggerMapSymbol].get(signingModalType.name) || [];
                const filteredPendingCallbacks = existingPendingCallbacks.filter((callback) => callback !== resolveTrigger);
                window[queuedTriggerMapSymbol].set(signingModalType.name, filteredPendingCallbacks);

                reject();
            }, FALLBACK_TIMEOUT_MS);

            const resolveTrigger = () => {
                clearTimeout(rejectTriggerTimeout);
                resolve();
            };

            const pendingCallbacks = window[queuedTriggerMapSymbol].get(signingModalType.name) || [];
            const newPendingCallbacks = [...pendingCallbacks, resolveTrigger];

            window[queuedTriggerMapSymbol].set(signingModalType.name, newPendingCallbacks);
            window[queuedArgumentsMapSymbol].set(signingModalType.name, args);

            return;
        }

        triggerCallback(...args);
        resolve();
    })

    close = (signingModalType, ...args) => {
        if (!isClient()) {
            return;
        }

        const closeCallback = window[closeApiMapSymbol].get(signingModalType.name);

        if (!closeCallback) {
            throw new Error(
                `No close callback is registered for ${signingModalType.name}`);
        }

        closeCallback(...args);
    }
}

export default new SigningModalManager();
